import { v4 as uuid } from 'uuid';

import { ImmerGet, ImmerSet } from '../types';

import { EditableBotVersionSlice, TaskValue } from '@/domain/bot';
import { isOpeningHoursTaskValue } from '@/utils/bot/opening-hours';
import { pushUndoAction } from 'utils/bot/state/editable-bot-fns';

/**
 * Creates task values table action handlers.
 */
export const createTaskValuesActions = (
    set: ImmerSet,
    get: ImmerGet,
): Pick<
    EditableBotVersionSlice,
    | 'addRowTaskValuesTable'
    | 'deleteRowTaskValuesTable'
    | 'resetTaskValuesTable'
    | 'updateTaskValuesTable'
    | 'updateCellTaskValuesTable'
> => ({
    addRowTaskValuesTable: () => {
        set((state) => {
            state.editingBot.taskValues.push({
                variableName: '',
                value: '',
                id: uuid(),
            });
            state.changesInBotVersion = true;
        });
    },

    deleteRowTaskValuesTable: (rowId: string) => {
        set((state) => {
            pushUndoAction(state, get);

            state.editingBot.taskValues = state.editingBot.taskValues.filter(
                (row) => row.id !== rowId,
            );
            state.changesInBotVersion = true;
        });
    },

    resetTaskValuesTable: () => {
        set((state) => {
            // Opening hours have no row in the table, so clearing it must not drop them.
            const preserved = state.editingBot.taskValues.filter(
                isOpeningHoursTaskValue,
            );

            state.editingBot.taskValues = [
                { variableName: '', value: '', id: uuid() },
                ...preserved,
            ];
            state.changesInBotVersion = true;
        });
    },

    updateTaskValuesTable: (taskValues: TaskValue[]) => {
        set((state) => {
            state.editingBot.taskValues = taskValues;
            state.changesInBotVersion = true;
        });
    },

    updateCellTaskValuesTable: (
        rowId: string,
        columnName: keyof TaskValue,
        updatedValue: string,
    ) => {
        set((state) => {
            pushUndoAction(state, get);

            const t = state.editingBot.taskValues.find(
                (row) => row.id === rowId,
            );
            if (t) {
                t[columnName] = updatedValue;
            }
            state.changesInBotVersion = true;
        });
    },
});
